<template>
  <div>
    <div class="field mt-2">
      <div class="columns">
        <div class="column">
          <label class="label is-italic has-text-weight-semibold">{{`Recipients * (${emails.length}/5)`}}</label>
        </div>
        <div class="column is-narrow">
          <button class="button is-size-3 is-outlined has-text-white"
          @click="clearAll()"
          :disabled="!emails.length" >Clear All</button>
        </div>
      </div>
      <div class="box">
        <div
            class="button has-background-black-bis has-text-white taghover m-1 p-1"
            v-for="(emp, idx) in emails"
            :key="idx"
            @click="removeExternalEmail(emp)"
          >
            <span>{{ emp }}</span>
            <i class="icon-close has-text-white"></i>
          </div>
      </div>
    </div>
    <div class="column">
      <div class="columns">
        <div class="column">
          <div class="field">
            <h4 class="is-size-3 is-italic">Add Manufacton Users</h4>
            </div>
              <search-bar class="mb-3"
                :shouldEmit="true"
                placeholder="Search"
                @search="getSearchValue($event)"
              />
              <div v-for="(option, key) in getUserList" :key="key"  class="users-box">
                <h3 class="is-italic
                    is-size-4
                    has-text-grey-dark
                    line-height">
                  {{ key }}
              </h3>
                <div v-for="user in option" :key="user.id">
                  <o-checkbox class="p-0 mb-1"
                    @update:modelValue="addUsers(user)"
                    v-model="user.checked"
                    :disabled="emails.length >= 5"
                    >
                    <span class="is-regular is-size-3 has-text-dark">
                      {{ user.name }}
                    </span>
                  </o-checkbox>
                </div>
              </div>
        </div>
        <div class="is-divider-vertical box-divider"></div> 
        <div class="column">
          <div class="field">
            <h4 class="is-size-3 is-italic">Add Email Recipients</h4>
            <div class="columns">
              <div class="column pr-0">
                <div class="field-body">
                  <div class="control  has-icons-left mb-2">
                    <input
                      class="input pl-1 border-color"
                      type="email"
                      v-model="emailInput"
                    />  
                  </div>
                </div>
              </div>
              <div class="column is-narrow">
                <button class="button has-background-black-bis has-text-white p-0" @click="addExternalEmail()">
                  <i class="icon-addnew"></i>
                </button>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, inject, reactive, toRefs } from 'vue';
  import { useToast } from 'vue-toastification';
  import Validate from '@/components/utils/Validations';
  import SearchBar from '@/components/SearchBar.vue';
  import _ from 'lodash';

  export default ({
    name: 'ShippingListsRecipientsTab',
    components: {
      'search-bar': SearchBar
    },
    props: {
      users: Object,
      recipientsEmails: Array,
    },

    setup(props, { emit }) {
      const emitter = inject('emitter');
      const toast = useToast();
      const data = reactive({
        emails: !_.isEmpty(props.recipientsEmails) ? props.recipientsEmails : [],
        emailInput: '',
        isLoading: false,
        searchText: ''
      });

      const getUserList = computed(() => {
        let list = {};
        for(const company in props.users) {
          const obj = props.users[company].filter((usr) => {
            if (usr.name.toLowerCase().includes(data.searchText.toLowerCase())) {
              return true;
            }
          })
          list[company] = obj;
        }
        return list;
      })

      const setUserChecked = (user, val) => {
        for(const company in props.users) {
          props.users[company].forEach((usr) => {
            if (usr.email ===  user.email) {
              usr.checked = val;
            }
        })
       }
      }

      const addEmail = (email) => {
        let toastErrorMessage = '';
        if(data.emails.length >= 5) return toast.error('Maximum of 5 emails allowed');

        const isEmailValid = Validate.validateEmail(email);
        if (!isEmailValid) toastErrorMessage = 'Please Enter Valid Email';

        const isEmailExisting = data.emails.includes(email);
        if (isEmailExisting) toastErrorMessage = 'Email Already Present';

        setUserChecked({email: email}, true);

        if (toastErrorMessage) {
          toast.error(toastErrorMessage);
          return;
        }

        data.emails.push(email);
        emitter.emit('emails', data.emails);
      }

      const addExternalEmail = () => {
        addEmail(data.emailInput);
        data.emailInput = '';
      }

      const addUsers = (user) => {
        if(data.emails.length >= 5){
          setUserChecked(user, false);
          return toast.error('Maximum of 5 emails allowed');  
        }
        if(!data.emails.includes(user.email)) {
          addEmail(user.email);
        } else {
          setUserChecked(user, false);
          data.emails = data.emails.filter((e) => e !== user.email);
          emitter.emit('emails', data.emails);
        }
      }

      const getSearchValue = (val) => {
       data.searchText = val;
      }

      const removeExternalEmail = (email) => {
        data.emails = data.emails.filter((e) => e !== email);
        setUserChecked({email: email}, false);
        emitter.emit('emails', data.emails);
      }

      const clearAll = () => {
        data.emails = [];
        emitter.emit('emails', data.emails);
        for(const company in props.users) {
          props.users[company].forEach((usr) => {
            usr.checked = false;
          })
        }
      }

      return {
        ...toRefs(data),
        clearAll,
        removeExternalEmail,
        addUsers,
        addExternalEmail,
        getSearchValue,
        getUserList,
      }
    }
  })
</script>